var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-auth"},[_c('div',{staticClass:"row box-content",class:{ 'auth-main' : _vm.metaRoute.mainPage === true }},[_c('div',{staticClass:"col-lg-12 col-sm-12 box-form"},[_c('router-view')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }